import { useLingui } from '@lingui/react';
import { Group } from '@mantine/core';
import { IconLayoutGrid } from '@tabler/icons-react';
import { SearchFilter } from '../Search/SearchFilter';
import { SearchInput } from '../Search/SearchInput';
import { sorts } from '../Search/data';
import { Icons } from '../Shares/Icons';
import { collections } from './data';
export const LootBoxesSearch: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group w="100%" justify="center">
      <Group justify="center" wrap="nowrap" py={20} gap={8} w={{
      base: '100%',
      lg: '90%'
    }}>
        <SearchInput />
        <SearchFilter w={222} label={i18n._('colLection:')} filters={collections} breakPoint="md">
          <IconLayoutGrid size={24} />
        </SearchFilter>
        <SearchFilter w={180} label={i18n._('Sort by:')} filters={sorts} breakPoint="md">
          <Icons className="icon-pr-line-filter" fontSize={24} />
        </SearchFilter>
      </Group>
    </Group>;
};